import { PRODUCT_NAME } from 'src/apps/dashboard/pages/issues/types/IssuesTypes';
import { IMobileUniqueIssuesResult } from 'src/apps/dashboard/types/MobileDashboardServiceTypes';
import { returnNonNull } from 'src/common/helpers/ArraysHelper';

import { MobileDashboardUniqueIssuesQuery } from '../MobileUniqueIssues.generated';

export const transformMobileUniqueIssuesResults = (
	rawResults: MobileDashboardUniqueIssuesQuery
): IMobileUniqueIssuesResult => {
	const issues =
		rawResults.mobile_unique_issues?.filter(returnNonNull).map((issue) => ({
			id: issue.signature,
			issueId: issue.last_issue_id,
			runId: issue.last_run_id,
			productName: issue.product_name as PRODUCT_NAME,
			issueType: issue.issue_type,
			severity: issue.severity,
			appId: issue.app_id,
			elementDescription: issue.element_description,
			firstSeen: issue.first_seen,
			lastSeen: issue.last_seen,
			instanceCount: issue.num_instances
		})) ?? [];

	const totalCount = rawResults.total?.[0]?.signature_count ?? 0;

	return {
		issues,
		totalCount,
		// mobile_unique_issues has no unfiltered-count query; the table's header count
		// and pagination total are both the filtered total here.
		unfilteredTotal: totalCount
	};
};
